import { render, staticRenderFns } from "./SoftbookSearchComponent.vue?vue&type=template&id=5802d51b&"
import script from "./SoftbookSearchComponent.ts?vue&type=script&lang=ts&"
export * from "./SoftbookSearchComponent.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SoftbookSearchComponent.vue"
export default component.exports